import { Instance } from 'mobx-state-tree';
import { ProjectDtoEdgeModelBase } from './ProjectDtoEdgeModel.base';

/* The TypeScript type of an instance of ProjectDtoEdgeModel */
export interface ProjectDtoEdgeModelType extends Instance<typeof ProjectDtoEdgeModel.Type> {}

/* A graphql query fragment builders for ProjectDtoEdgeModel */
export { selectFromProjectDtoEdge, projectDtoEdgeModelPrimitives, ProjectDtoEdgeModelSelector } from './ProjectDtoEdgeModel.base';

/**
 * ProjectDtoEdgeModel
 */
export const ProjectDtoEdgeModel = ProjectDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
